import { render, staticRenderFns } from "./RdStationConfigCard.vue?vue&type=template&id=67b203d2&scoped=true&"
import script from "./RdStationConfigCard.vue?vue&type=script&lang=ts&"
export * from "./RdStationConfigCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b203d2",
  null
  
)

export default component.exports